<mat-pseudo-checkbox
  *ngIf="multiple"
  class="mat-option-pseudo-checkbox"
  [state]="selected ? 'checked' : 'unchecked'"
  [disabled]="disabled"
></mat-pseudo-checkbox>

<span class="mat-option-text" #text><ng-content></ng-content></span>

<div
  class="mat-option-ripple"
  mat-ripple
  [matRippleTrigger]="_getHostElement()"
  [matRippleDisabled]="disabled || disableRipple"
></div>
